import React from 'react';

interface ConnectionStatusBannerProps {
    message: string;
}

const ConnectionStatusBanner: React.FC<ConnectionStatusBannerProps> = ({ message }) => {
    if (!message) return null;

    return (
        <div className="bg-yellow-100 dark:bg-yellow-900/50 border-b border-yellow-200 dark:border-yellow-800 text-yellow-800 dark:text-yellow-200 text-sm text-center py-2 px-4 z-50" role="alert">
            <p>{message}</p>
        </div>
    );
};

export default ConnectionStatusBanner;
